<template>
  <div>
    <div class="odmik-dodajanja-narocnine vsebina-inline" v-if="!moznostVnosaSmsPotrditve">
      <div class="open-sans-16pt">
        <b>
          Povezava naročnine s podatki
          <span class="mobile-display">
            portala Horizont
          </span>
        </b>
      </div>
      <div class="postavitev-input">
        <el-form label-width="170px"
                 ref="narocninaForm"
                 :label-position="formaOrientacija"
                 class="nova-vrstica-forma"
                 @keyup.native.enter="DodajNarocninoSStaroPrijavo"
                 :model="novaNarocnina"
                 :rules="novaNarocninaRules">
          <el-form-item label="Uporabniško ime" prop="uporabniskoIme">
            <el-input placeholder="Vnesite uporabniško ime" v-model="novaNarocnina.uporabniskoIme"
                      class="velikost-inputa">
            </el-input>
          </el-form-item>
          <el-form-item label="Uporabniško geslo" style="label: none;" prop="uporabniskoGeslo" class="class-uporabnisko-geslo">
            <el-input placeholder="Vnesite geslo" type="password" v-model="novaNarocnina.uporabniskoGeslo"
                      class="velikost-inputa" id="input-geslo">
              <i slot="suffix" class="fa fa-eye-slash" id="ikonaEyeSlashGeslo"
                 @click="PrikazGesla('input-geslo')" v-if="prikazeIkonoNovoGeslo">
              </i>
              <i slot="suffix" class="fa fa-eye" id="ikonaEyeGeslo"
                 @click="PrikazGesla('input-geslo')" v-else>
              </i>
            </el-input>
          </el-form-item>
<!--          <el-form-item prop="preverjanjeStarosti" class="odmik-preverjanja-starosti">-->
<!--            <el-checkbox v-model="novaNarocnina.preverjanjeStarosti">-->
<!--              Potrjujem, da sem star/-a 18 let-->
<!--            </el-checkbox>-->
<!--          </el-form-item>-->
        </el-form>
      </div>
      <div class="odmik-gumba obstojeca">
        <el-button type="primary" @click="GetPotrditvenoGeslo"
                   class="gumb-potrdi gumb-potrdi-sirina"
                   :loading="obstojecaNarocninaBtnLoader">
          DODAJ NAROČNINO
        </el-button>
      </div>
    </div>
    <div v-if="moznostVnosaSmsPotrditve && prikaziFormoZaSmsObstojeca">
      <p class="navadno-besedilo levo-brez-odmika">
        Za uspešno povezavo prosimo vpišite geslo, ki smo vam ga pravkar poslali na kontaktno mobilno številko, ki
        se konča z {{gsmZaPrikaz}}.
      </p>
      <el-form label-width="170px"
               ref="potrdiNarocninoForm"
               :label-position="formaOrientacija"
               class="nova-vrstica-forma"
               @submit.native.prevent="DodajNarocninoSStaroPrijavo"
               :model="token"
               :rules="tokenRules">
        <el-form-item label="Potrditveno geslo" prop="geslo">
          <el-input placeholder="Vpišite geslo" v-model="token.geslo" class="velikost-inputa">
          </el-input>
        </el-form-item>
      </el-form>
      <div class="odmik-gumba">
        <el-button type="primary" @click="DodajNarocninoSStaroPrijavo" class="gumb-potrdi gumb-potrdi-sirina"
                   :loading="obstojecaNarocninaBtnLoader">
          POTRDI GESLO
        </el-button>
        <a class="stil-gumb-preklici" @click="PrekliciDodajanjeNarocnine" type="primary">
          PREKLIČI
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import {Input, Button, Collapse, CollapseItem, Col} from 'element-ui'
import ClientAgent from '../../../../../../assets/js/clientAgent.js'
import {PrikazVsebine} from '../../../../../../assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna'
import {HTTPResponseCodes} from '../../../../../../assets/js/Enum/ResponseCodes/HTTPResponseCodes'

export default {
  name: 'DodajObstojece',
  mixins: [PrikazVsebine],
  components: {
    [Button.name]: Button,
    [Input.name]: Input,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Col.name]: Col
  },
  data () {
    return {
      clientAgent: null,
      nosilecNarocnine: false,
      formaOrientacija: 'left',
      mejnaSirina: 600,
      obstojecaNarocninaBtnLoader: false,
      prikazeIkonoNovoGeslo: false,
      prikaziFormoZaSmsObstojeca: false,
      novaNarocnina: {
        uporabniskoIme: '',
        uporabniskoGeslo: ''
        // preverjanjeStarosti: []
      },
      novaNarocninaRules: {
        uporabniskoIme: [
          {
            validator: this.ValidirajUpIme
          }
        ],
        uporabniskoGeslo: [
          {
            validator: this.ValidirajGeslo
          }
        ]
        // preverjanjeStarosti: [
        //   {
        //     validator: this.ValidirajStarost
        //   }
        // ]
      },
      token: {
        geslo: ''
      },
      tokenRules: {
        geslo: [
          {required: true, message: 'Prosimo, vpišite potrditveno geslo.', trigger: 'blur'},
          {min: 6, message: 'Potrditveno geslo mora vsebovati vsaj 6 znakov.'}
        ]
      },
      gsmZaPrikaz: ''
    }
  },
  props: {
    moznostVnosaSmsPotrditve: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
  },
  methods: {
    GetPotrditvenoGeslo () {
      let isValid = false
      this.$refs['narocninaForm'].validate((valid) => {
        isValid = valid
      })
      if (!isValid) {
        return false
      }
      this.obstojecaNarocninaBtnLoader = true
      let param = ['username=' + this.novaNarocnina.uporabniskoIme]
      param.push('password=' + this.novaNarocnina.uporabniskoGeslo)
      this.clientAgent.postWsRequest(
        this,
        'subscriptions/getConfirmationPassword?',
        param,
        null,
        'SetPotrditvenoGeslo',
        'ErrPotrditvenoGeslo')
    },
    SetPotrditvenoGeslo (podatki) {
      this.obstojecaNarocninaBtnLoader = false
      if (podatki.gsmNumber !== '') {
        this.gsmZaPrikaz = podatki.gsmNumber
      }
      // this.novaNarocnina.preverjanjeStarosti = []
      this.ShowSuccessMessage(podatki)
      this.$emit('posodobiTokenFormo', true)
      this.prikaziFormoZaSmsObstojeca = true
    },
    ErrPotrditvenoGeslo (podatki) {
      this.obstojecaNarocninaBtnLoader = false
      let paramObvestilo = {}
      if (podatki.statusCode === HTTPResponseCodes.UNAUTHORIZED) {
        paramObvestilo.message = 'Naročniški podatki se ne ujemajo s podatki, vnesenimi na pogodbi.\n' +
          'Prosimo, da se oglasite v T-2 poslovalnici in uredite ustreznost podatkov.\n' +
          'Za pomoč smo na voljo tudi na številki 064 064 064.'
      } else {
        paramObvestilo.message = podatki.message
      }
      this.ShowWarningMessage(paramObvestilo)
      this.prikaziFormoZaSmsObstojeca = false
    },
    ValidirajUpIme (rule, upIme, callback) {
      if (upIme.length === 0) {
        return callback(new Error('Prosimo, vpišite uporabniško ime.'))
      }
      callback()
    },
    ValidirajGeslo (rule, geslo, callback) {
      if (geslo.length === 0) {
        return callback(new Error('Prosimo, vpišite uporabniško geslo.'))
      }
      callback()
    },
    ValidirajStarost (rule, starost, callback) {
      if (starost.length === 0) {
        return callback(new Error('Prosim potrdite, da ste starejši od 18 let.'))
      }
      callback()
    },
    PrikazGesla (id) {
      let element = document.getElementById(id)
      if (element.type === 'password') {
        element.type = 'text'
        if (id === 'input-geslo') {
          this.prikazeIkonoNovoGeslo = false
        }
      } else {
        element.type = 'password'
        if (id === 'input-geslo') {
          this.prikazeIkonoNovoGeslo = true
        }
      }
    },
    DodajNarocninoSStaroPrijavo () {
      let isValid = false
      this.$refs['potrdiNarocninoForm'].validate((valid) => {
        isValid = valid
      })
      if (!isValid) {
        return false
      }
      this.obstojecaNarocninaBtnLoader = true
      let param = ['username=' + this.novaNarocnina.uporabniskoIme]
      param.push('password=' + this.novaNarocnina.uporabniskoGeslo)
      param.push('confirmationCode=' + this.token.geslo)
      this.clientAgent.postWsRequest(
        this,
        'subscriptions/addWithOldCredentials?',
        param,
        null,
        'SetPrijavaZstarimRcunom',
        'ErrPrijavaZstarimRcunom')
    },
    SetPrijavaZstarimRcunom () {
      this.obstojecaNarocninaBtnLoader = false
      // this.novaNarocnina.preverjanjeStarosti = []
      this.novaNarocnina.uporabniskoGeslo = ''
      this.novaNarocnina.uporabniskoIme = ''
      this.$emit('osveziPodatke')
      this.$emit('posodobiTokenFormo', false)
      this.prikaziFormoZaSmsObstojeca = false
    },
    ErrPrijavaZstarimRcunom (podatki) {
      this.obstojecaNarocninaBtnLoader = false
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    PrekliciDodajanjeNarocnine () {
      this.$emit('posodobiTokenFormo', false)
      this.novaNarocnina.sap = ''
      this.novaNarocnina.davcna = ''
      this.obstojecaNarocninaBtnLoader = false
      this.prikaziFormoZaSmsObstojeca = false
    }
  }
}
</script>

<style scoped src="../../../../../../../static/css/Narocnine/DodajanjeNarocnin.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Mojprofil/DodajanjeNarocnin/DodajanjeNarocninKomponente/DodajObstojece.vue